export default __webpack_public_path__ + "static/blog3-c6ebbcc8ee5c1874cababd55d5bddcff.jpg";